<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'My Tasks'"></Breadcrumbs>
      <TaskGrid></TaskGrid>
    </div>
  </v-row>
</template>

<script>
import TaskGrid from "@/components/tasks/TaskGrid.vue";
import { createNamespacedHelpers } from "vuex";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Tasks",
  components: {
    TaskGrid,
    Breadcrumbs,
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },
};
</script>
